// extracted by mini-css-extract-plugin
module.exports = {"container":"smallQRCode-module--container--3P4oC","smallQRCode":"smallQRCode-module--smallQRCode--1XWUz","informationBlock":"smallQRCode-module--informationBlock--1QZ4q"};